import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import getCookie from 'ati-utils/getCookie';
import Logger from './logger';
import ErrorBoundary from 'components/ErrorBoundary';
__webpack_public_path__ = window.publicPath;

const renderFooter = () => {
    try {
        window.RenderFooter({
            hideFlags: false,
        });

    } catch (e) {
        //ignored
    }
};

export const init = config => {
    const locale = getCookie('uicult')?.split('-')[0] || 'ru';
    const atiApp = getCookie('atiapp');
    const isAtiApp = atiApp && atiApp === '1';

    const getLogger = () => {
        try {
            return new Logger(config.sentryRelease, config.isSentryActive);
        } catch {
            return null;
        }
    };

    ReactDOM.render(
        <React.StrictMode>
            <ErrorBoundary
                locale={locale}
                logger={getLogger()}
            >
                <App
                    isAtiApp={isAtiApp}
                    locale={locale}
                />
            </ErrorBoundary>
        </React.StrictMode>,
        document.getElementById('root')
    );

    /* eslint-disable no-console */
    const cl = console.log;
    console.log = (...args) => { //Нам нинужны чужие вакансии
        if (typeof args[0] === 'string' && args[0]?.startsWith('%cПсст')) {
            return;
        }
        cl(...args);
    };
    /* eslint-enable no-console */

    renderFooter();
};
